import { gql } from "@apollo/client";
import { messageHeaders } from "features/common/fragments";

export const INSURANCE_DOCUMENT_DUPLICATED = gql`
  subscription insuranceDocumentDuplicated($sourceDocumentId: Int!) {
    insuranceDocumentDuplicated(sourceDocumentId: $sourceDocumentId) {
      documentNumber
      documentId
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;
